import React from 'react';
import { Button } from '../components/ui/Button';
import { Card, CardHeader, CardBody } from '../components/ui/Card';
import { CtaSection } from '../components/sections/CtaSection';
import { CalendarIcon, MessageSquareIcon, MailIcon, PhoneIcon } from 'lucide-react';
export function Contact() {
  return <div className="pt-20 bg-[#F4E8D0]/30" data-id="element-766">
      {/* Hero */}
      <section className="bg-[#0099A1] py-20" data-id="element-767">
        <div className="container mx-auto px-4 md:px-6" data-id="element-768">
          <div className="max-w-3xl" data-id="element-769">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-770">
              Contact Us
            </h1>
            <p className="text-xl text-white/90" data-id="element-771">
              Ready to go from boardroom to beach? Let's start planning your
              exceptional event.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Options */}
      <section className="py-16 bg-white" data-id="element-772">
        <div className="container mx-auto px-4 md:px-6" data-id="element-773">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-774">
            <h2 className="text-3xl font-bold text-[#374047] mb-4" data-id="element-775">
              Get in Touch
            </h2>
            <p className="text-lg text-[#374047]/80" data-id="element-776">
              Choose the method that works best for you. Our team is ready to
              help plan your perfect event.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-777">
            <Card className="text-center h-full" data-id="element-778">
              <CardHeader className="flex flex-col items-center" data-id="element-779">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#0099A1]/10 mb-4" data-id="element-780">
                  <CalendarIcon className="h-8 w-8 text-[#0099A1]" data-id="element-781" />
                </div>
                <h3 className="text-xl font-bold text-[#374047]" data-id="element-782">
                  Book a Call
                </h3>
              </CardHeader>
              <CardBody data-id="element-783">
                <p className="text-[#374047]/80 mb-6" data-id="element-784">
                  Schedule a 15-minute discovery call with our team to discuss
                  your event needs.
                </p>
                <Button variant="primary" href="https://calendly.com/ashsingh/destameet-discovery-call" target="_blank" rel="noopener noreferrer" data-id="element-785">
                  Book Discovery Call
                </Button>
              </CardBody>
            </Card>
            <Card className="text-center h-full" data-id="element-786">
              <CardHeader className="flex flex-col items-center" data-id="element-787">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#0099A1]/10 mb-4" data-id="element-788">
                  <MessageSquareIcon className="h-8 w-8 text-[#0099A1]" data-id="element-789" />
                </div>
                <h3 className="text-xl font-bold text-[#374047]" data-id="element-790">WhatsApp</h3>
              </CardHeader>
              <CardBody data-id="element-791">
                <p className="text-[#374047]/80 mb-6" data-id="element-792">
                  Connect with us instantly via WhatsApp for quick questions and
                  inquiries.
                </p>
                <Button variant="outline" className="bg-[#25D366] text-white border-[#25D366] hover:bg-[#25D366]/90" href="https://api.whatsapp.com/send?phone=19052152109" target="_blank" rel="noopener noreferrer" data-id="element-793">
                  Start WhatsApp Chat
                </Button>
              </CardBody>
            </Card>
            <Card className="text-center h-full" data-id="element-794">
              <CardHeader className="flex flex-col items-center" data-id="element-795">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#0099A1]/10 mb-4" data-id="element-796">
                  <MailIcon className="h-8 w-8 text-[#0099A1]" data-id="element-797" />
                </div>
                <h3 className="text-xl font-bold text-[#374047]" data-id="element-798">Email Us</h3>
              </CardHeader>
              <CardBody data-id="element-799">
                <p className="text-[#374047]/80 mb-6" data-id="element-800">
                  Send us an email with your event details and we'll respond
                  within 24 hours.
                </p>
                <Button variant="outline" href="mailto:experience@destameet.com" data-id="element-801">
                  experience@destameet.com
                </Button>
              </CardBody>
            </Card>
          </div>

          {/* RFP Button */}
          <div className="max-w-3xl mx-auto" data-id="element-802">
            <h2 className="text-2xl font-bold text-[#374047] mb-6 text-center" data-id="element-803">
              Request for Proposal
            </h2>
            <Card data-id="element-804">
              <CardBody className="text-center py-12" data-id="element-805">
                <p className="text-lg text-[#374047]/80 mb-8 max-w-2xl mx-auto" data-id="element-806">
                  Ready to get started? Fill out our detailed proposal form and
                  we'll create a custom plan tailored to your event needs.
                </p>
                <Button variant="primary" size="lg" href="https://form.typeform.com/to/x5iwnyZM" target="_blank" rel="noopener noreferrer" data-id="element-807">
                  Request for Proposal
                </Button>
              </CardBody>
            </Card>
          </div>
        </div>
      </section>

      <CtaSection data-id="element-808" />
    </div>;
}